import { createSimpleComponent } from '../sagov-base-component';
import html from 'raw-loader!./template.html';

createSimpleComponent(html, 'sagov-required');
